import { useState, useRef, useEffect } from "react";
import { Modal } from 'react-bootstrap';
import DeviceService from "../../Services/DeviceService";
import { ReactComponent as Save } from '../../Assets/img/Edit-icon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import moment from "moment";
import $ from 'jquery';

/**
 * Renders edit device pop up to edit device
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 * @param {Event} props.deviceId to unique identifier of devices
 */
function EditDevice(props) {

    //#region States 

    const [isActive, setIsActive] = useState(false);
    const [isForRegistration, setIsForRegistration] = useState(false);
    const [DeviceModels, setDeviceModels] = useState([]);
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);
    const [date, setDate] = useState("");
    const [device, setDevice] = useState({});

    //#endregion

    //#region Refs

    const deviceModelIdRef = useRef();
    const deviceNameRef = useRef();
    const serialNumRef = useRef();

    //#endregion

    //#region useEffect hook

    /**
    * Calls device service to fetch device models and devices 
    * Runs on every render
   */

    useEffect(() => {
        DeviceService.GetDeviceModels().then((getDeviceModelResponse) => {
            if (getDeviceModelResponse.response == null) {
                setError(getDeviceModelResponse.errors[0].message);
            } else {
                setDeviceModels(getDeviceModelResponse.response);
            }
        }).catch((err) => {
            setError(err.data);
        });

        DeviceService.GetDevice(props.deviceId).then((getDeviceResponse) => {
            if (getDeviceResponse.response == null) {
                setError(getDeviceResponse.errors[0].message);
            } else {
                setDevice(getDeviceResponse.response);
                setIsActive(getDeviceResponse.response.IsActive);
                setIsForRegistration(getDeviceResponse.response.IsItForRegistration);
                var parsedDate = new Date(moment(getDeviceResponse.response.ValidityDateTime, "DD/MM/YYYY").format("YYYY-MM-DD")).setHours(0, 0, 0, 0);
                setDate(parsedDate);
            }
        }).catch((err) => {
            setError(err.data);
        });
    }, [])

    //#endregion

    //#region Edit device

    /**
    * Calls device service to edit device
    * @param  {Event} event  User action (on submitting form)
    */

    async function editDevice(event) {
        event.preventDefault();

        let DeviceDetailDTO = {
            DeviceModelId: deviceModelIdRef.current.value,
            Name: ((deviceNameRef.current.value === "") ? null : deviceNameRef.current.value),
            ValidityDateTime: moment(date).format('DD/MM/YYYY').toString(),
            SerialNum: ((serialNumRef.current.value === "") ? null : serialNumRef.current.value),
            IsActive: isActive,
            IsItForRegistration: isForRegistration,
        };

        DeviceService.UpdateDeviceDetail(props.deviceId, DeviceDetailDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage("Device edited sucessfully.");
                }
            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    //#endregion

    function messagePopupCloseHandler() {
        setError("");
        setMessagePopup(false);
    }

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>
            <Modal.Header className="AddDeviceHeader" style={{ border: "none" }} closeButton>
                <Modal.Title className="Header"><strong>Edit Device</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={editDevice}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="DeviceModel" className="label">Device Model</label>
                            <div>
                                <select id="deviceModel" className="InputField" ref={deviceModelIdRef} required>
                                    {DeviceModels?.map((DeviceModel) => (
                                        <option value={DeviceModel.Id} selected={DeviceModel.Id == device.DeviceModelId ? true : false}>{DeviceModel.Make}-{DeviceModel.Model}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="DeviceName" className="label">Device Name</label>
                            <div>
                                <input type="text" min="0" maxlength="30" className="InputField" ref={deviceNameRef} defaultValue={device.Name} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="SerialNo" className="label">Serial No</label>
                            <div>
                                <input type="text" min="0" maxlength="100" className="InputField" ref={serialNumRef} defaultValue={device.SerialNum} required />
                            </div>
                        </div>
                    </div>
                    <Modal.Footer className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" onClick={() => {
                                var deviceModel = "";

                                DeviceModels?.map((DeviceModel) => (
                                    DeviceModel.Id == device.DeviceModelId ? (deviceModel = deviceModel + ("<option value='" + DeviceModel.Id + "' selected>" + DeviceModel.Make + "-" + DeviceModel.Model + "</option>")) :
                                        deviceModel = deviceModel + ("<option value='" + DeviceModel.Id + "'>" + DeviceModel.Make + "-" + DeviceModel.Model + "</option>")
                                ))

                                $('#deviceModel').html(deviceModel);
                                setIsActive(device.IsActive);
                                setIsForRegistration(device.IsItForRegistration);
                                var parsedDate = new Date(moment(device.ValidityDateTime, "DD/MM/YYYY").format("YYYY-MM-DD")).setHours(0, 0, 0, 0);
                                setDate(parsedDate);
                            }}>
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><Save /></span>
                                <span className="primary-button-text">Edit</span>
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal.Body>

        </Modal >
    );
}

export default EditDevice;